<template>
  <div>
    <div @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="调班"
      :visible.sync="dialogTableVisible"
      append-to-body
      width="656px"
      destroy-on-close
      :reverse="true"
    >
      <div class="student-detail">
        <el-tag type="warning" style="margin: 0 0 12px 20px"
          >“调班”操作不会影响教师的流失数据！</el-tag
        >
        <div class="student-info">学员信息:</div>
        <div class="student-info-detail">
          <p>学员姓名: {{ studentInfo.student.name }}</p>
          <p>
            手机号:
            {{
              "+" +
              studentInfo.student.area_code +
              " " +
              studentInfo.student.mobile
            }}
          </p>
          <p>授课状态: 授课中</p>
        </div>
      </div>
      <el-form
        size="mini"
        :model="searchInfo"
        @submit.native.prevent
        :rules="rules"
        ref="form"
      >
        <el-form-item label="备注信息" prop="remarks">
          <el-input
            type="textarea"
            v-model="searchInfo.remarks"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="btns">
          <el-button class="mwow-button-filled mini" @click="handleCancel"
            >取消</el-button
          >
          <el-button
            class="mwow-button-filled success mini"
            @click="handleConfirm"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { adjustClassApi } from "@/api/teacherManage";
export default {
  props: ["studentInfo"],
  data() {
    return {
      dialogTableVisible: false,
      num: 3,
      detailInfo: [],
      searchInfo: {
        remarks: "",
      },
      rules: {
        remarks: [
          { required: true, message: "请填写备注信息", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    showDialog() {
      this.searchInfo.remarks = "";
      this.dialogTableVisible = true;
    },
    handleCancel() {
      this.dialogTableVisible = false;
    },
    handleConfirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          adjustClassApi({
            relation_id: this.studentInfo.relation_id,
            remark: this.searchInfo.remarks,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "调班成功",
              });
              this.dialogTableVisible = false;
              this.$emit("change");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.student-detail {
  margin: 0 -20px;
  border-bottom: 1px solid #e7e8ea;
  .student-info {
    font-size: 14px;
    margin-left: 20px;
  }
  .student-info-detail {
    display: flex;
    padding: 20px 0 20px 30px;
    p {
      margin-right: 40px;
    }
  }
}
.footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
/deep/ .el-form-item__label {
  margin-top: 10px;
  font-size: 14px;
}
/deep/ .el-textarea__inner {
  height: 70px !important;
  resize: none;
}
</style>
